import type { ReactNode } from 'react';

import { Card } from 'src/app/components/Elements/Card';
import { AdjustableCardItem } from 'src/app/components/Elements/Card/AdjustableCardItem';

import { StylizedText } from './styles';

interface EmptyStateCardProps {
  addTopMarginToAllCards?: boolean;
  height: number;
  image?: ReactNode;
  text: string;
  textStyle: 'blueBold' | 'grayNormal';
}

export const EmptyStateCard = ({
  addTopMarginToAllCards = true,
  height,
  image,
  text,
  textStyle,
}: EmptyStateCardProps) => (
  <Card addTopMarginToAllCards={addTopMarginToAllCards}>
    <AdjustableCardItem height={height}>
      {image}
      <StylizedText textStyle={textStyle}>{text}</StylizedText>
    </AdjustableCardItem>
  </Card>
);
